import { render, staticRenderFns } from "./_program.vue?vue&type=template&id=12f4be33&scoped=true&"
import script from "./_program.vue?vue&type=script&lang=js&"
export * from "./_program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4be33",
  null
  
)

export default component.exports